import React from "react";

const GlobalContext = React.createContext();

function GlobalProvider(props) {
  const [modalOpen, setModalOpen] = React.useState();
  const [processModalOpen, setProcessModalOpen] = React.useState();
  const [altaCentroModalOpen, setModalAltaCentroOpen] = React.useState();
  const [modalData, setModalData] = React.useState();
  const [ModalData, setModalAltaCentroData] = React.useState();/*$$*/
  const [newTaskOpen, setNewTaskOpen] = React.useState();
  const [selectTaskOpen, setSelectTaskOpen] = React.useState();
  const [newTaskData, setNewTaskData] = React.useState();
  const [taskType, setTaskType] = React.useState();
  const [eventDate, setEventDate] = React.useState();
  const [myTasks, setMyTasks] = React.useState();
  const [allTasks, setAllTasks] = React.useState();
  const [currentTab, setCurrentTab] = React.useState(0);
  const [currentDate, setCurrentDate] = React.useState();
  const [currentView, setCurrentView] = React.useState();
  const [userProperties, setUserProperties] = React.useState();
  const [alertOpen, setAlertOpen] = React.useState();
  const [alertType, setAlertType] = React.useState();
  const [alertTitle, setAlertTitle] = React.useState();
  const [alertMessage, setAlertMessage] = React.useState();
  const [handleAccept, setHandleAccept] = React.useState();
  const [alertBarOpen, setAlertBarOpen] = React.useState();
  const [alertBarMessage, setAlertBarMessage] = React.useState();
  const [alertBarSeverity, setAlertBarSeverity] = React.useState();
  const [refreshTable, setRefreshTable] = React.useState();

  React.useEffect(() => {
    setModalOpen(false);
	setModalAltaCentroOpen(false);
    setProcessModalOpen(false);
    setNewTaskOpen(false);
    setSelectTaskOpen(false);
    setModalData({});
    setRefreshTable(0);
  }, []);

  return (
    <GlobalContext.Provider
      value={{
        modalOpen, setModalOpen,
		altaCentroModalOpen, setModalAltaCentroOpen,
        modalData, setModalData,
        processModalOpen, setProcessModalOpen,
        newTaskOpen, setNewTaskOpen,
        newTaskData, setNewTaskData,
        taskType, setTaskType,
        selectTaskOpen, setSelectTaskOpen,
        eventDate, setEventDate,
        myTasks, setMyTasks,
        allTasks, setAllTasks,
        currentTab, setCurrentTab,
        currentDate, setCurrentDate,
        currentView, setCurrentView,
        userProperties, setUserProperties,
        alertOpen, setAlertOpen,
        alertType, setAlertType,
        alertTitle, setAlertTitle,
        alertMessage, setAlertMessage,
        handleAccept, setHandleAccept,
        alertBarOpen, setAlertBarOpen,
        alertBarMessage, setAlertBarMessage,
        alertBarSeverity, setAlertBarSeverity,
        refreshTable, setRefreshTable
      }}
    >
      {props.children}
    </GlobalContext.Provider>
  );
}

export { GlobalContext, GlobalProvider };